import autobind from 'core-decorators/lib/autobind';
import { VODCSSModules } from 'shared/utils/wix-connect';

import WixSDK from 'shared/utils/wix-sdk';

import { getNormalizedCachedDimensions } from 'widget/utils/normalize-image-dimensions';

import styles from './resized-image.styl';


@VODCSSModules(styles)
export default class ResizedImage extends React.Component {

  static propTypes = {
    src: React.PropTypes.string,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    params: React.PropTypes.object,
    style: React.PropTypes.object,
    className: React.PropTypes.string,
    children: React.PropTypes.any,
  };

  static defaultProps = {
    params: {},
    style: {},
  };

  state = {
    resizedThumbnailUrl: null,
  };

  componentDidMount() {
    this.replaceResizedImage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.replaceResizedImage(nextProps);
  }

  componentWillUnmount() {
    clearTimeout(this.preloadTimeout);
  }

  preloadImagePromise = Promise.resolve();
  lastLoadedImage = null;
  preloadTimeout = null;

  replaceResizedImage({ src, width, height, params }) {
    const dimensions = getNormalizedCachedDimensions(src, {
      containerWidth: width,
      containerHeight: height,
    });

    const url = WixSDK.Utils.Media.getResizedImageUrl(src, ...dimensions, params);

    if (this.lastLoadedImage === url) {
      return;
    }

    this.lastLoadedImage = url;

    clearTimeout(this.preloadTimeout);

    // to avoid unnecessary requests, because of channel cover rendered initially,
    // and only after it removed we got video cover loading.
    this.preloadTimeout = setTimeout(() => {
      this.preloadImagePromise
        .then(() => new Promise(resolve => {
          const image = new Image();
          image.onload = () => resolve(url);
          image.src = url;
        }))
        .then(loadedImageUrl => {
          if (!this.resizedImageRef) {
            return;
          }
          this.setState({ resizedThumbnailUrl: loadedImageUrl });
        });
    });
  }

  @autobind
  handleRefUpdate(resizedImageRef) {
    this.resizedImageRef = resizedImageRef;
  }

  render() {
    const { className, width, height, style, children } = this.props;

    const styles = {
      width,
      height,
      ...style,
    };

    const { resizedThumbnailUrl } = this.state;

    if (resizedThumbnailUrl) {
      styles.backgroundImage = `url(${resizedThumbnailUrl})`;
    }

    return (
      <div styleName="resized-image"
           className={className}
           style={styles}
           ref={this.handleRefUpdate}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/resized-image/resized-image.js